import { Navigate, useLocation } from "react-router-dom";
import { UseAuth } from "./Auth";
import { readOrderQuery, hasOrderCredentials } from "../../utils/orderQuery";

/**
 * Lets a request through when it either has an authenticated session or carries
 * order lookup credentials in the URL. The backend re-validates those
 * credentials on every call - this only decides whether to show the login form.
 */
function RequireAuth({ children }) {
  const auth = UseAuth();
  const location = useLocation();

  const credentials = readOrderQuery(location);

  if (auth.isAuthenticated || hasOrderCredentials(credentials) || location.state) {
    return children;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
}

export default RequireAuth;
